import { Characterization } from './characterization';
import { FunctionPerformed } from './function-performed';

export class CharacterizationFunctionPerformed {
  characterization?: Characterization;
  functionPerformed: FunctionPerformed;
  state?: boolean;
}
